import React from 'react'
import PageHeading from '../layout/PageHeading'
import JobOfferBadge from './Badge'

// Optionally accept jobOffer for badge
export type HeaderProps = {
  heading: string
  jobOffer?: { company: { logoSrc?: string }, title: string }
  size?: 'sm' | 'md'
  color?: string
}

const JobHeader: React.FC<HeaderProps> = ({ heading, jobOffer, size = 'md', color = 'black' }) => (
  <div className='my-2 flex flex-col md:flex-row md:items-center gap-4 lg:gap-12 w-full max-w-5xl mx-auto justify-center text-center bg-soft-green p-2 rounded-lg'>
    <div className='inline-block w-sm'>
      {size === 'md' ? (
        <PageHeading noMargin showGoBack={false}>{heading}</PageHeading>
      ) : (
        <div className={`text-sm text-${color}`}>{heading}</div>
      )}
    </div>
    {jobOffer && (
      <div>
        <JobOfferBadge imgSrc={jobOffer.company.logoSrc ?? ''} title={jobOffer.title} color={color} />
      </div>
    )}
  </div>
)

export default JobHeader
